import { render, staticRenderFns } from "./UniversalKey.vue?vue&type=template&id=7bc335d8&scoped=true"
import script from "./UniversalKey.vue?vue&type=script&lang=js"
export * from "./UniversalKey.vue?vue&type=script&lang=js"
import style0 from "./UniversalKey.vue?vue&type=style&index=0&id=7bc335d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc335d8",
  null
  
)

export default component.exports